import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ServiceAdvisorService } from './service-advisor.service';

@Component({
  selector: 'app-service-advisor',
  templateUrl: './service-advisor.component.html',
  styleUrls: ['./service-advisor.component.scss'],
  standalone: false
})
export class ServiceAdvisorComponent implements OnInit {
  bucketurl = environment.bucketUrl;
  displayedColumns: string[] = ['SNo', 'dealer_code', 'dealer_map_code', 'loc_code', 'smpin', 'emp_code', 'emp_name', 'designation', 'status', 'action'];
  // Text inputs of the form; lengths mirror the service_advisor table columns
  formFields = [
    { key: 'dealer_code', label: 'Dealer Code', maxlength: 50, required: true },
    { key: 'dealer_map_code', label: 'Dealer Map Code', maxlength: 50, required: true },
    { key: 'loc_code', label: 'Location Code', maxlength: 50, required: false },
    { key: 'smpin', label: 'SMPIN', maxlength: 50, required: true },
    { key: 'emp_code', label: 'Employee Code', maxlength: 50, required: true },
    { key: 'emp_name', label: 'Employee Name', maxlength: 150, required: true },
    { key: 'designation', label: 'Designation', maxlength: 100, required: false },
  ];
  public ELEMENT_DATA: any = [];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);
  isLoading: Subject<boolean> = new Subject<boolean>();
  @ViewChild(MatSort, { static: true })
  sort: MatSort = new MatSort;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  serviceAdvisorForm: FormGroup;
  constructor(private toastr: ToastrService, private fb: FormBuilder, @Inject(ServiceAdvisorService) private serviceAdvisorService: ServiceAdvisorService) {
    const controls: any = {};
    this.formFields.forEach(field => {
      controls[field.key] = ['', field.required ? [Validators.required, this.notBlank] : []];
    });
    controls['status'] = ['', Validators.required];
    this.serviceAdvisorForm = this.fb.group(controls);
  }

  public isCreate: boolean = false;
  public isEdit: boolean = false;
  public submitted: boolean = false;

  ngOnInit() {
    this.getList();
  }

  get f() { return this.serviceAdvisorForm.controls; }

  notBlank(control: any) {
    return control.value && !String(control.value).trim() ? { required: true } : null;
  }

  add() {
    this.isCreate = true;
  }

  selectedObject: any = {}
  editData(object: any) {
    this.isEdit = true;
    this.selectedObject = object;
    const values: any = {};
    this.formFields.forEach(field => values[field.key] = object[field.key] || '');
    values.status = object.status ? 1 : 0;
    this.serviceAdvisorForm.patchValue(values);
  }

  back() {
    this.clearForm();
    this.selectedObject = {};
    this.isCreate = false;
    this.isEdit = false;
    this.getList();
  }

  private buildPayload(flag: string) {
    const formData = this.serviceAdvisorForm.value;
    const obj: any = {};
    this.formFields.forEach(field => obj[field.key] = (formData[field.key] || '').trim());
    obj.status = parseInt(formData.status);
    obj.flag = flag;
    return obj;
  }

  create() {
    this.submitted = true
    if (this.serviceAdvisorForm.valid) {
      const obj = this.buildPayload('create');
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.serviceAdvisorService.serviceAdvisorCrud(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Service advisor created successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  update() {
    this.submitted = true
    if (this.serviceAdvisorForm.valid) {
      const obj = this.buildPayload('update');
      obj.id = this.selectedObject.id;
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.serviceAdvisorService.serviceAdvisorCrud(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Service advisor updated successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  clearForm() {
    this.submitted = false;
    const values: any = { status: '' };
    this.formFields.forEach(field => values[field.key] = '');
    this.serviceAdvisorForm.patchValue(values);
  }

  getList() {
    let reqObject = {
      flag: 'list'
    }
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.serviceAdvisorService.serviceAdvisorCrud(reqObject).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.ELEMENT_DATA = responseData.data || []
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    }, (err) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  public searchInput = new FormControl("");
  applyFilter() {
    const filterValue = this.searchInput.value ? this.searchInput.value.trim().toLowerCase() : '';

    this.dataSource.filterPredicate = (data: any, filter: string) => {
      return this.formFields.some(field => (data[field.key] || '').toString().toLowerCase().includes(filter));
    };
    this.dataSource.filter = filterValue;
  }
  clearSearch() {
    this.searchInput.setValue('');
    this.applyFilter();
  }
}
